import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";
import "index.css";
import client from "./graphql/apollo-client";
import { ApolloProvider } from "@apollo/client";
import { handleChunkLoadError } from "utils/errorHandling";
import { initVersionGuard } from "utils/versionGuard";

handleChunkLoadError();

// Reload onto the latest deployed build if this tab is running a stale one.
initVersionGuard();

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
